var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('div',{staticClass:"icon",style:(_vm.getStyles),on:{"click":function($event){return _vm.$emit('onClick')}}},[_c(_vm.iconLoader,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }